import { BasicAuthServiceHelper } from '@/modules/Auth'
import APIRoutes from './APIRoutes'
import { flattenMapping, invertFlatMapping, transformObject } from './dataTransformer'

// Define a mapping between app keys and API keys
const transformationMap = {
  avatar: 'b64Avatar',
  images: 'b64Images',
  description: 'selfDescription',
  years: 'workExperiences',
  dog: 'dogExperiences',
  cat: 'catExperiences',
  certification: 'diplomas',
  volunteering: 'volontateering',
  souvenir: 'memories',
  learnt: 'experienceDescription',
  why: 'objectives',
  pets: {
    dog: 'animalsSupport.dog',
    cat: 'animalsSupport.cat',
    nac: 'animalsSupport.nac',
  },
  age: 'minAge',
  sizes: {
    small: 'weights.little',
    medium: 'weights.medium',
    big: 'weights.big',
    'very-big': 'weights.very-big',
    giant: 'weights.giant',
  },
  accepted: {
    'in-heat': 'petsittingCriteria.heatPeriod',
    'sick-animals': 'petsittingCriteria.sickAnimals',
    'oral-meds': 'petsittingCriteria.oralDrugAdministration',
    'syringe-meds': 'petsittingCriteria.syringeDrugAdministration',
    'old-animals': 'petsittingCriteria.elderlyAnimals',
    puppies: 'petsittingCriteria.puppy',
    'complicated-characters': 'petsittingCriteria.complexCharacter',
    'specific-needs': 'petsittingCriteria.animalsWithSpecificNeeds',
    'daily-activity': 'petsittingCriteria.needDailyExercise',
  },
  informations: 'aditionalInformations',
  engagement: 'acceptTakeInformated',
  tarifs: {
    promenade: {
      demitarif: 'services.walk.halfHourRate',
      tarif: 'services.walk.hourlyRate',
      petscount: 'services.walk.maxAnimals',
    },
    gardehome: {
      tarif: 'services.homeCare.nightRate',
      petscount: 'services.homeCare.maxAnimals',
    },
    garde: {
      tarif: 'services.sittingAtHome.nightRate',
      petscount: 'services.sittingAtHome.maxAnimals',
    },
    visite: {
      demitarif: 'services.homeVisit.halfHourRate',
      tarif: 'services.homeVisit.hourlyRate',
      petscount: 'services.homeVisit.maxAnimals',
    },
  },
  discountpetcount: 'degressiveRatesByAnimalsNumber',
  summerholidays: 'summerRate',
  xmasholidays: 'winterRate',
  charity: 'supportCharity',
  liveplace: 'livingSpace',
  habitationzone: 'residentialAreaType',
  athome: {
    'neutered-male-dog': 'homeOptions.ownANeuteredMaleDog',
    'non-neutered-male-dog': 'homeOptions.ownAnUnNeuteredMaleDog',
    'spayed-female-dog': 'homeOptions.ownASpayedFemaleDog',
    'non-spayed-female-dog': 'homeOptions.ownAnUnspayedFemaleDog',
    'male-cat': 'homeOptions.ownAMaleCat',
    'female-cat': 'homeOptions.ownAFemaleCat',
    'young-children': 'homeOptions.hasYoungChildren',
  },
  homeDescription: 'homeDescription',
  parcorforest: 'natureProximity',
  smoke: 'tabagism',
  purina: 'subscribePurinaOptins',
  annulation: 'cancellationPolicy',
  ranges: 'disponibilitiesPeriods',
}

// Flatten the mapping
export const flatMap = flattenMapping(transformationMap)
// Invert the flattened mapping
export const reverseMap = invertFlatMapping(flatMap)

// Fetch profile from the API and transform it to app format
export const getProfileAsync = async (returnState = false) => {
  const { path: urlPath, method } = APIRoutes.GetRegistration
  const getProfileResponse = (await BasicAuthServiceHelper.requestAuthenticatedAsync(`${urlPath}`, method)) as {
    state: any
  }

  const transformedState = transformObject(getProfileResponse.state, reverseMap)

  const transformedData = {
    ...getProfileResponse,
    state: transformedState,
  }

  return returnState ? transformedData.state : transformedData
}

// Update profile by transforming app data to API format and sending the update
export const updateProfileAsync = async (data, update?: boolean) => {
  const transformedData = transformObject(data, flatMap)

  const { path: urlPath, method } = update ? APIRoutes.UpdateRegistration : APIRoutes.PostRegistration
  const response = await BasicAuthServiceHelper.requestAuthenticatedAsync(`${urlPath}`, method, transformedData)

  return response
}
